import { Code as TiptapCode } from "@tiptap/extension-code";

import { ActionButton } from "../../components";

export const Code = TiptapCode.extend({
	addOptions() {
		return {
			...this.parent?.(),
			button: ({ editor, t }) => ({
				component: ActionButton,
				componentProps: {
					action: () => editor.commands.toggleCode(),
					isActive: () => editor.isActive("code") || false,
					icon: "Code",
					shortcutKeys: ["mod", "E"],
					tooltip: t("editor.code.tooltip")
				}
			})
		};
	}
});
